import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { SparklinesBars, SparklinesLine, Sparklines } from "react-sparklines";

import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { IoIosNotifications } from "react-icons/io";
//Import Components
import { BgCard } from "../../elements/CardDesign";
import { IMAGES } from "../../constant/theme";
import CkEditorBlog from "../../elements/CkEditor/CkEditorBlog";
import { BiExport, BiImport } from "react-icons/bi";
import { getDashboardDataApi } from "../../../services/apis/Dashboard";
import { FaMinus, FaSignInAlt, FaSignOutAlt, FaUserEdit } from "react-icons/fa";
import { FaUserPlus } from "react-icons/fa6";
import { RiLockPasswordLine, RiUserAddFill } from "react-icons/ri";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { TiUserDelete } from "react-icons/ti";
import { getLogActivityDataApi } from "../../../services/apis/LogActivityApi";
import { FiPlus } from "react-icons/fi";
import { MdEdit } from "react-icons/md";

//Charts
const SurveyChart = loadable(() =>
  pMinDelay(import("../../elements/dashboard/SurveyChart"), 500)
);
const DonughtChart = loadable(() =>
  pMinDelay(import("../../elements/dashboard/DonughtChart"), 500)
);
const University = loadable(() =>
  pMinDelay(import("../../elements/dashboard/University"), 500)
);

const detailCard = [
  {
    title: "When Is the Best Time to Take an Education Course?",
    name: "Jack Ronan",
    image: IMAGES.course1,
  },
  {
    title: "Education Courses: A Guide to Unlocking Your Potential",
    name: "Jimmy Morris",
    image: IMAGES.course2,
  },
  {
    title: "A Comprehensive Guide to Taking an Education Course",
    name: "Konne Backfield",
    image: IMAGES.course3,
  },
  {
    title: "Why Should You Consider Taking an Education Course?",
    name: "Nashid Martines",
    image: IMAGES.course4,
  },
];

const examTable = [
  { roll: "542", name: " Jack Ronan" },
  { roll: "360", name: "Jimmy Morris" },
  { roll: "450", name: "Samantha" },
  { roll: "296", name: "Roman Aurora" },
  { roll: "520", name: "Nashid Martines" },
  { roll: "620", name: "Daigno" },
];

const tabelData = [
  {
    no: "01",
    name: "Jack Ronan",
    proff: "Airi Satou",
    date: "02 jan 2024",
    status: "Checkin",
    color: "primary",
    subject: "Commerce",
    fees: "120",
  },
  {
    no: "02",
    name: "Jimmy Morris",
    proff: "Angelica Ramos",
    date: "02 jan 2024",
    status: "Pending",
    color: "warning",
    subject: "Mechanical",
    fees: "205",
  },
  {
    no: "03",
    name: "Nashid Martines",
    proff: "Ashton Cox",
    date: "04 jan 2024",
    status: "Canceled",
    color: "danger",
    subject: "Science",
    fees: "180",
  },
  {
    no: "04",
    name: "Roman Aurora",
    proff: "Cara Stevens",
    date: "05 jan 2024",
    status: "Process",
    color: "info",
    subject: "Arts",
    fees: "200",
  },
  {
    no: "05",
    name: "Samantha",
    proff: "Bruno Nash",
    date: "06 jan 2024",
    status: "Checkin",
    color: "primary",
    subject: "Maths",
    fees: "210",
  },
];

const notifyData = [
  { title: "Login successfully" },
  { title: "User created successfully" },
  { title: "User Updated successfully" },
  { title: "Sultads Send you Photo" },
  { title: "Report created successfully" },
  { title: "Profile updated successfully" },
  { title: "Report created successfully" },
  { title: "Reminder : Treatment Time!" },
];

const Home = () => {
  const [dashboardData, setDashboardData] = useState({});
  const [activityData, setActivityData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  // console.log("activityData",activityData)

  const bgCarddBlog = [
    {
      title: "Total Users",
      number: dashboardData?.total_users?.toString(),
      icon: <i className="la la-users" />,
      percent: "100%",
      color: "primary",
      to: "#",
    },
    {
      title: "ICAI Users",
      number: dashboardData?.icai_users?.toString(),
      icon: <i className="la la-user" />,
      percent: "100%",
      color: "warning",
      to: "/icai-user-list",
    },
    {
      title: "Non ICAI Users",
      number: dashboardData?.non_icai_users?.toString(),
      icon: <i className="la la-user" />,
      percent: "100%",
      color: "secondary",
      to: "/non-icai-list",
    },
    {
      title: "Log Activity",
      number: dashboardData?.log_activity?.toString(),
      icon: <i className="la la-history" />,
      percent: "100%",
      color: "danger",
      to: "/log-activities",
    },
  ];

  const getDashboardData = async () => {
    try {
      const response = await getDashboardDataApi();
      setDashboardData(response?.data?.data);
    } catch (err) {
      console.log("error", err);
    }
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  const GetLogActivityData = async () => {
    try {
      const res = await getLogActivityDataApi(currentPage);
      const resData = res?.data;
      setActivityData(resData);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    GetLogActivityData();
  }, [currentPage]);

  // <div className="widget-timeline dlab-scroll style-1 p-3 height370">
  // 	     <ul className="timeline">
  // 		  <li>
  // 			<div className="timeline-badge primary" />
  // 			<Link
  // 			  className="timeline-panel c-pointer text-muted"
  // 			  to="#">
  // 			  <span>10 minutes ago</span>
  // 			  <h6 className="mb-0">
  // 				Youtube, a video-sharing website, goes live{" "}
  // 				<strong className="text-primary">$500</strong>.
  // 			  </h6>
  // 			</Link>
  // 		  </li>
  // 		  <li>
  // 			<div className="timeline-badge info"></div>
  // 			<Link
  // 			  className="timeline-panel c-pointer text-muted"
  // 			  to="#">
  // 			  <span>20 minutes ago</span>
  // 			  <h6 className="mb-0">
  // 				New order placed{" "}
  // 				<strong className="text-info">#XF-2356.</strong>
  // 			  </h6>
  // 			  <p className="mb-0">
  // 				Quisque a consequat ante Sit amet magna at
  // 				volutapt...
  // 			  </p>
  // 			</Link>
  // 		  </li>
  // 		  <li>
  // 			<div className="timeline-badge danger"></div>
  // 			<Link
  // 			  className="timeline-panel c-pointer text-muted"
  // 			  to="#">
  // 			  <span>30 minutes ago</span>
  // 			  <h6 className="mb-0">
  // 				john just buy your product{" "}
  // 				<strong className="text-warning">Sell $250</strong>
  // 			  </h6>
  // 			</Link>
  // 		  </li>
  // 		  <li>
  // 			<div className="timeline-badge success"></div>
  // 			<Link
  // 			  className="timeline-panel c-pointer text-muted"
  // 			  to="#">
  // 			  <span>15 minutes ago</span>
  // 			  <h6 className="mb-0">
  // 				StumbleUpon is acquired by eBay.{" "}
  // 			  </h6>
  // 			</Link>
  // 		  </li>
  // 		  <li>
  // 			<div className="timeline-badge warning"></div>
  // 			<Link
  // 			  className="timeline-panel c-pointer text-muted"
  // 			  to="#">
  // 			  <span>20 minutes ago</span>
  // 			  <h6 className="mb-0">
  // 				Mashable, a news website and blog, goes live.
  // 			  </h6>
  // 			</Link>
  // 		  </li>
  // 		  <li>
  // 			<div className="timeline-badge dark"></div>
  // 			<Link
  // 			  className="timeline-panel c-pointer text-muted"
  // 			  to="#">
  // 			  <span>20 minutes ago</span>
  // 			  <h6 className="mb-0">
  // 				Mashable, a news website and blog, goes live.
  // 			  </h6>
  // 			</Link>
  // 		  </li>
  // 		</ul>
  // 	 </div>

  const getLogDetails = (logType) => {
    switch (logType) {
      case "login":
        return { icon: <FaSignInAlt size={20} />, className: "text-success" };
      case "logout":
        return {
          icon: (
            <FaSignOutAlt size={20} style={{ transform: "rotate(180deg)" }} />
          ),
          className: "text-danger",
        };
      case "signup":
        return { icon: <FaUserPlus size={20} />, className: "text-info" };
      case "changepassword":
        return {
          icon: <RiLockPasswordLine size={20} />,
          className: "text-warning",
        };
      case "export":
        return { icon: <BiExport size={20} />, className: "text-blue" };
      case "import":
        return { icon: <BiImport size={20} />, className: "text-indigo" };
      case "adduser":
        return { icon: <RiUserAddFill size={20} />, className: "text-success" };
      case "useredit":
        return { icon: <FaUserEdit size={20} />, className: "text-warning" };
      case "delete":
        return { icon: <TiUserDelete size={20} />, className: "text-danger" };
      case "employeecreate":
        return { icon: <RiUserAddFill size={20} />, className: "text-success" };
      case "employeeedit":
        return { icon: <FaUserEdit size={20} />, className: "text-warning" };
      case "employeedelete":
        return { icon: <TiUserDelete size={20} />, className: "text-danger" };
      case "exportlogactivity":
        return { icon: <BiExport size={20} />, className: "text-blue" };
      case "importimage":
        return { icon: <BiImport size={20} />, className: "text-info" };

      case "createrole":
        return { icon: <FiPlus size={20} />, className: "text-success" };
      case "roleedit":
        return { icon: <MdEdit size={20} />, className: "text-info" };
      case "roledelete":
          return { icon: <FaMinus size={20} />, className: "text-danger" };;
   
      default:
        return {
          icon: <IoIosNotifications size={20} />,
          className: "text-gray",
        }; // Default case
    }
  };

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  // console.log("dashboardData",dashboardData?.user_creation_stats)
  return (
    <>
      <Row>
        {bgCarddBlog?.map((item, index) => (
          <Col xl={"3"} xxl={"3"} sm={"6"} key={index}>
            <Link to={item?.to}>
              <div className={`widget-stat card bg-${item.color}`}>
                <div className="card-body">
                  <BgCard
                    title={item?.title}
                    number={item?.number}
                    percent={item?.percent}
                    color={item?.color}
                    icon={item?.icon}
                    dashboardData={dashboardData}
                  />
                </div>
              </div>
            </Link>
          </Col>
        ))}
        <Col xl={"6"} xxl={"6"} lg={"12"} sm={"12"}>
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Users</h3>
            </div>
            <div className="card-body">
              {dashboardData?.user_creation_stats?.labels?.length > 0 && (
                <SurveyChart surveyData={dashboardData?.user_creation_stats} />
              )}
            </div>
          </div>
        </Col>

        <Col xl={"6"} xxl={"6"} sm={"6"}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Log Activity</h4>
            </div>
            <div className="card-body">
              <div
                className="widget-todo dz-scroll"
                style={{ height: "320px" }} >
                <ul className="timeline">
                  {activityData?.all_logs?.map((item, i) => {
                    const { icon, className } = getLogDetails(item?.logType);
                    return (
                      <li key={i}>
                        <div className="timeline-badge primary"></div>
                        <div className="timeline-panel text-muted mb-3 d-flex align-items-center">
                          <span className={`${className}`}>{icon}</span>
                          <div className="col px-3">
                            <h5 className="mb-1 text-capitalize">
                              {item?.description}
                            </h5>
                            <small className="d-block">
                              {moment(item?.createdAt).format(
                                "DD MMM YYYY - hh:mm A"
                              )}
                            </small>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>

              <div className="pagination-container">
                <ReactPaginate
                  pageCount={Math.ceil(
                    activityData?.pagination?.totalLogs /
                      activityData?.pagination?.rowPerPage
                  )}
                  pageRangeDisplayed={1}
                  marginPagesDisplayed={2}
                  onPageChange={handlePageClick}
                  containerClassName="pagination"
                  activeClassName="selected"
                  disabledClassName="disabled"
                />
              </div>
            </div>
          </div>
        </Col>

        {/* <Col xl={"6"} xxl={"6"} sm={"6"}>
				<div className="card">
						<div className="card-header">
							<h3 className="card-title">	Users Chart</h3>
						</div>
						<div className="card-body">
							<DonughtChart />							
						</div>
					</div>
					</Col> */}
        {/* <Col xl={"3"} xxl={"3"} sm={"6"}>
					<div className="card">
						<div className="card-header">
							<h3 className="card-title">Survey</h3>
						</div>
						<div className="card-body">							
							<University />
						</div>
					</div>
				</Col> */}
        {/* {detailCard.map((item, ind)=>(
					<Col xl={"3"} md={"6"} key={ind}>
						<div className="card">
							<img className="img-fluid rounded-top" src={item.image} alt="" />
							<div className="card-body">
								<h4><Link to={"/about-courses"}>{item.title}</Link></h4>
								<ul className="list-group mb-3 list-group-flush">
									<li className="list-group-item px-0 border-top-0 d-flex justify-content-between"><span className="mb-0">April 23</span>
										<Link to={"#"} className="add-wishlist-btn">
											<i className="la la-heart-o outline" />
											<i className="la la-heart fill" />
											<span>450</span>
										</Link>
									</li>
									<li className="list-group-item px-0 d-flex justify-content-between">
										<span className="mb-0">Duration :</span><strong>12 Months</strong>
									</li>
									<li className="list-group-item px-0 d-flex justify-content-between">
										<span className="mb-0">Professor :</span><strong>{item.name}</strong>
									</li>
									<li className="list-group-item px-0 d-flex justify-content-between">
										<span><i className="fa fa-graduation-cap text-primary me-2" />Student</span><strong>+120</strong>
									</li>
								</ul>
								<Link to={"/about-courses"} className="btn btn-primary">Read More</Link>
							</div>
						</div>
					</Col>
				))} */}
        {/* <Col lg={"6"}>
					<div className="card">
						<div className="card-body">
							<form action="#" method="post">
								<div className="form-group">
									<div className="input-group mb-3">
										<span className="input-group-text">To</span>
										<input type="text" className="form-control" placeholder="Username" />
									</div>
									<div className="input-group mb-3">
										<span className="input-group-text">Subject</span>
										<input type="text" className="form-control" placeholder="Subject" />
									</div>
								</div>
								<div className="form-group">
									<div className="custom-ekeditor">										
										<CkEditorBlog />
									</div>
								</div>
								<div className="row align-items-center my-3">
									<div className="col-xl-6">
										<div className="mb-xl-0 mb-3">
											<input type="file" className="form-control" data-default-file="" />
										</div>
									</div>
									<div className="col-xl-6 ">
										<button type="submit" className="btn btn-primary float-xl-end">
											Send <i className="fa fa-paper-plane-o" />
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</Col> */}
        {/* <Col lg={"6"}>
					<div className="card">
						<div className="card-header">
							<h4 className="card-title">Details</h4>
						</div>
						<div className="card-body">
							<div className="table-responsive">
								<table className="table verticle-middle text-nowrap">
									<thead>
										<tr>
											<th scope="col">No.</th>
											<th scope="col">Name</th>
											<th scope="col">Status</th>
											<th scope="col">Edit</th>
										</tr>
									</thead>
									<tbody>
										{examTable.map((item, ind)=>(
											<tr key={ind}>
												<td>{item.roll}</td>
												<td>{item.name}</td>
												<td>
													<span id="widget_sparklinedash">
														<Sparklines data={[20, 25,28, 30, 34, 38, 45, 50, 52, 55, 58, 60, 64, 68, 72]}>
															{ind % 2 === 0 ? 
																<SparklinesBars style={{ stroke: "white", strokeWidth: "1", fill: "#40c0f5" }} /> 
																:															
																<SparklinesLine color="blue" />
															}
														</Sparklines>
													</span>
												</td>
												<td>													
													<Link to={"#"} className="btn btn-xs sharp btn-primary me-1"><i className="fa fa-pencil" /></Link>
													<Link to={"#"} className="btn btn-xs sharp btn-danger"><i className="fa fa-trash" /></Link>
												</td>
											</tr>
										))}
										
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</Col> */}
        {/* <Col>
					<div className="card">
						<div className="card-header">
							<h4 className="card-title">List</h4>
						</div>
						<div className="card-body pt-2">
							<div className="table-responsive recentOrderTable">
								<table className="table verticle-middle text-nowrap table-responsive-md">
									<thead>
										<tr>
											<th scope="col">No.</th>
											<th scope="col">Name</th>
											<th scope="col">Date</th>
											<th scope="col">Status</th>
											<th scope="col">Price</th>
											<th scope="col">Edit</th>
										</tr>
									</thead>
									<tbody>
										{tabelData?.map((item, index)=>(
											<tr key={index}>
												<td>{item.no}</td>
												<td>{item.name}</td>
												<td>{item.date}</td>
												<td><span className={`badge badge-rounded badge-${item.color}`}>{item.status}</span></td>
												<td>{item.fees}$</td>
												<td>
													<Link to={"/edit-student"} className="btn btn-xs sharp btn-primary me-1"><i className="fa fa-pencil" /></Link>
													<Link to={"#"} className="btn btn-xs sharp btn-danger"><i className="fa fa-trash" /></Link>
												</td>
											</tr>
										))}

									</tbody>
								</table>
							</div>
						</div>				
					</div>				
				</Col> */}
      </Row>
    </>
  );
};
export default Home;
